<template>
    <div>
        <el-row :gutter="10" v-loading="loading">
            <el-col :span="6" class="el-col-image" v-for="(item,index) in news" :key="index"
                    @click.native="click(item,index)">
                <el-card class="el-card" shadow="always" :class="{elColSelect: itemSelectStatus[index]}"
                         body-style="padding : 0 0">
                    <el-image :src="item.content.news_item[0].thumb_url"/>
                    <div style="padding: 10px 10px;background-color: cornflowerblue;">
                        <el-tooltip class="item" effect="dark" :content="item.content.news_item[0].title"
                                    placement="bottom">
                            <span class="image-name">{{format(item.content.news_item[0].title)}}</span>
                        </el-tooltip>
                        <div>
                            <span class="image-time">{{formatDate(item.update_time)}}</span>
                        </div>
                    </div>

                    <el-button class="el-button-select" v-if="itemSelectStatus[index]" type="success"
                               icon="el-icon-check" circle/>
                </el-card>
            </el-col>
        </el-row>
        <el-pagination
                class="el-pagination"
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="param.count"
                :pager-count="5"
                :total="param.totalCount">
        </el-pagination>
    </div>
</template>

<script>
    export default {
        name: "NewsShowDialog",
        data() {
            return {
                param: {
                    type: "news",
                    offset: 0,
                    count: 8,
                    totalCount: 0
                },
                loading: false,
                news: [],
                itemSelectStatus: [],
                currentPage: 1,
                currentItem: {}
            }
        },
        methods: {
            newsInfos() {
                this.loading = true;
                this.$api.material.batchGetMaterial(this.param).then(data => {
                    this.param.totalCount = data.total_count;
                    this.news = data.item;
                    this.fillSelectStatus(this.news.length);
                    this.loading = false;
                });
            },
            click(item, index) {
                this.currentItem = item;
                this.fillSelectStatus(this.news.length);
                this.itemSelectStatus[index] = true;
                this.$emit("itemClick", this.currentItem);
            },
            formatDate(str) {
                return this.$DateUtis.StringToDate(str, "yyyy-MM-dd hh:mm:ss");
            },
            fillSelectStatus(len) {
                this.itemSelectStatus = new Array(len).fill(false);
            },
            handleCurrentChange(val) {
                this.param.offset = (val - 1) * this.param.count;
                this.currentPage = val;
                this.newsInfos();
            },
            handleSizeChange(val) {
                this.param.count = val;
                this.newsInfos();
            },
            format(str) {
                return this.$StringUtils.splice(str, 10);
            },
        },
        mounted() {
            this.newsInfos();
        }
    }
</script>

<style scoped>
    .el-col {
        margin-bottom: 10px;
    }

    .el-image {
        height: 140px;
        width: 100%;
        display: block;
    }

    .image-name {
        font-size: 12px;
        width: 100%;
    }

    .image-time {
        font-size: 12px;
        width: 100%;
    }

    .el-col-image {
        /*float: left;*/
        /*width: 20%;*/
        position: relative;
    }

    .elColSelect {
        border: 2px solid #67c23a !important;
    }

    .el-card {
        border: 2px solid #EBEEF5
    }

    .el-button-select {
        position: absolute;
        top: 0;
        right: 5px;
    }

    .confirm {
        position: absolute;
        right: 0;
        top: 0;
    }

    .el-pagination {
        width: 20px;
    }

    .bottom-div {
        width: 100%;
        position: relative;
    }
</style>